import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAppVariables } from "../../../../reducers/settings/app_variables";
import { IAppVariables } from "../../../../types/ApiInterfaces";
import getBiofuelList from "../../../../api/sustainability/storage/reconciliation/getBiofuelList";
import ReconciliationList from "./ReconciliationList";
import {useBiofuelReconciliationStyles} from "../../../../common/styles/RawMaterial";

const useStyles = useBiofuelReconciliationStyles;

interface Props {
  app_variables: IAppVariables;
}

const BiofuelReconciliationView: React.FC<Props> = ({ app_variables }) => {
  const [lists, setLists] = useState<{}>({});
  const classes = useStyles();
  const dispatch = useDispatch();

  const getReconciliationList = async () => {
    const res = await getBiofuelList();

    if (res && res.valid) {
        const sortedByTerminals = Object.keys(res.data).sort();
        const sortedTerminalsObject = {};
        sortedByTerminals.forEach(terminal => {
            const sortedByBiofuel = Object.keys(res.data[terminal]).sort();
            const sortedBiofuelObject = {};
            sortedByBiofuel.forEach(biofuel => {
                sortedBiofuelObject[biofuel] = res.data[terminal][biofuel];
            });
            sortedTerminalsObject[terminal] = sortedBiofuelObject;
        });
        setLists(sortedTerminalsObject);
    }
  };

  useEffect(() => {
    let isMounted = true;
    getReconciliationList();
    if (isMounted) { // Only update the state if the component is still mounted
      dispatch(getAppVariables());
    }
    return () => { // Add a cleanup function to cancel any ongoing tasks
      isMounted = false;
    };
  }, []);
  return (
    <div className={classes.root}>
      <Grid container justify="space-between" alignItems="center" style={{ marginBottom: "24px" }}>
        <Grid item>
          <Typography variant="h2" className={classes.h2}>
            Stock Reconciliation
          </Typography>
        </Grid>
      </Grid>
      {Object.keys(lists).length === 0 ? (
        <Typography variant="subtitle1">No volume to reconcile</Typography>
      ) : (
        Object.keys(lists).map((terminal, index) => (
          <Card key={index} style={{ marginBottom: "24px" }}>
            <CardContent className={classes.cardTable}>
              <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ marginBottom: "16px" }}
                  className={classes.cardContent}
              >
                <Grid item xs>
                  <Typography variant="subtitle1" style={{ fontWeight: "bold"}}>
                    {terminal}
                  </Typography>
                </Grid>
              </Grid>
              <ReconciliationList data={lists[terminal]} terminal={terminal} />
            </CardContent>
          </Card>
        ))
      )}
    </div>
  );
};

export default BiofuelReconciliationView;
